import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilterObject } from '../filter-object';
import { StringHelper } from '../string-helper';

@Component({
  selector: 'text-field-filter',
  templateUrl: './text-field-filter.component.html',
  styleUrls: ['./text-field-filter.component.scss']
})
export class TextFieldFilterComponent implements OnInit {
  @Input()
  filterObject: FilterObject;

  @Input()
  width: number;

  @Output()
  filterValueChanged = new EventEmitter<any>();

  filterClicked = false;

  public widthStyle: any;

  ngOnInit(): void {
    this.widthStyle = this.width == null ? null : { 'width.px': this.width };
    if (this.filterObject != null && this.filterObject.value == null) {
      this.filterObject.value = '';
    }
  }

  public onFilterValueChange(filterValue: any): void {
    this.filterObject.value = (<HTMLInputElement>filterValue).value;
    this.filterObject.active = !StringHelper.isEmpty(this.filterObject.value);
    this.filterValueChanged.emit(this.filterObject);
  }
}
